import template from './employee_view_general_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeViewGeneralComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_fields_lookup = ko.observableArray();
		this.employee_fields_expiring = ko.observableArray();
		this.employee_id = ko.observable();
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.qualifications = ko.observableArray();
		this.is_app_invite_visible = ko.observable(false);
		this.id_types = ko.observableArray();
		this.id_countries = ko.observableArray();
		this.selected_id_type = ko.observable();
		this.selected_id_country = ko.observable();
		this.id_type_label = ko.observable('ID number');

		// Get the current date
		let today = new Date();
		let formattedDate = today.toISOString().split('T')[0];

		this.date_current = ko.observable(formattedDate);

		if (bindings.employee && ko.isObservable(bindings.employee))
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv);
					this.loadPage();
				}
			})

		this.update_date_of_birth = this.update_date_of_birth.bind(this);
		this.save_personal_details = this.save_personal_details.bind(this);
		this.save_educational_details = this.save_educational_details.bind(this);
		this.save_qualification = this.save_qualification.bind(this);
		this.add_field = this.add_field.bind(this);
		this.delete_qualification = this.delete_qualification.bind(this);
		this.upload_photo = this.upload_photo.bind(this);
		this.delete_photo = this.delete_photo.bind(this);
		this.send_invitation_email = this.send_invitation_email.bind(this);
		this.send_app_email = this.send_app_email.bind(this);
		this.cancel_save_personal_details = this.cancel_save_personal_details.bind(this);
		this.edit_disciplinary_details = this.edit_disciplinary_details.bind(this);
		this.cancel_save_disciplinary_details = this.cancel_save_disciplinary_details.bind(this);
		this.save_disciplinary_details = this.save_disciplinary_details.bind(this);

		this.has_educational_fields = ko.computed(() => {
			return this.employee_fields_lookup().some(category =>
				category.sub_category === 'Educational' && category.resdata.length > 0
			);
		});

		this.has_disciplinary_fields = ko.computed(() => {
			return this.employee_fields_lookup().some(category =>
				category.sub_category === 'Disciplinary' && category.resdata.length > 0
			);
		});

		this.selected_id_type.subscribe((val) => {
			if (val === 'SA ID')
				this.selected_id_country('South Africa'); // Set selected_id_country to "South Africa"
			else
				this.selected_id_country('Any Country Not On This List');

			if (val === 'Passport')
				this.id_type_label('Passport number');
			else
				this.id_type_label('ID number');
		});

		let Qualification = function (config) {
			let data
			data = $.extend(
				{
					education_id: null,
					employee_id: bindings.id,
					qualification: '',
					date_received: '',
					institution: '',
				}, config);

			ko.mapping.fromJS(data, {}, this);
		}

		this.add_qualification = () => {
			this.qualifications.unshift(new Qualification());
			let row = $('#qualifications_body > tr:nth-child(1)');
			row.find('.edit').show();
			row.find('.view').hide();
		}

		this.updateData();
	}

	async updateData()
	{
		if (this.bindings.onReload && this.bindings.onReload instanceof Function)
			this.bindings.onReload.apply(null, []);
		await this.loadPage();
	}

	async loadPage()
	{
		if (!this.employee())
			return;

		if (this.employee().id_type == 'Passport')
			this.id_type_label('Passport number');
		else
			this.id_type_label('ID number');

		let options = {
			table: 'setting',
			schema: 'grape',
		}

		let result = await Grape.fetches.getJSON('/api/record', options);

		if (result.value == 'true')
			this.is_app_invite_visible(true);
		else
			this.is_app_invite_visible(false);

		this.employee_id(this.employee().employee_id);

		let res = await Grape.fetches.postJSON('/employee/field_lookups', {
			employee_id: this.employee_id(),
		});

		let fields_mapped = {};
		this.employee().fields.forEach((f) => {
			fields_mapped[f.field_name] = {
				field_value: f.field_value,
				valid_date: f.valid_date,
			}
		});

		let id_type = await Grape.fetches.getJSON('/api/record', {
			table: 'id_types',
			schema: 'public',
		});

		if (id_type.status != 'ERROR')
			this.id_types(id_type.records);

		let id_countries = await Grape.fetches.getJSON('/api/record', {
			table: 'id_countries',
			schema: 'public',
			limit: 300,
		});

		if (id_countries.status != 'ERROR')
			this.id_countries(id_countries.records);

		this.selected_id_type(this.employee().id_type);
		this.selected_id_country(this.employee().id_country);

		// wrap in categories
		let tempArray = {}
		res.forEach((a) => {
			if (tempArray[a.employee_field_category] == null)
				tempArray[a.employee_field_category] = { category: a.employee_field_category, sub_category: a.employee_field_sub_category_name, resdata: [] };

			let obj = a;
			obj.field_value = fields_mapped[obj.field_name]['field_value'];
			obj.valid_date = fields_mapped[obj.field_name]['valid_date'];
			tempArray[a.employee_field_category].resdata.push(obj);
		});

		let ar = [];
		Object.keys(tempArray).forEach((key) => {
			ar.push(tempArray[key]);
		});

		this.employee_fields_lookup(ar);
		console.log('employee fields lookup', this.employee_fields_lookup());

		// Here we set the visibilty on the send mobile app invite button
		let x = await Grape.fetches.getJSON('/api/setting/mobile.instance');
		if (x.value == 'true')
			this.is_app_invite_visible(true);
		else
			this.is_app_invite_visible(false);

		let res_education = await Grape.fetches.postJSON('/employee/get_education', { employee_id: this.employee_id() });

		if (res_education.employee_education)
			this.qualifications(res_education.employee_education);
		else
			this.qualifications.removeAll();

		let validDateSpans = document.querySelectorAll('.valid_date[data-bind="text: valid_date"]');
		let currentDate = new Date();

		validDateSpans.forEach((span) => {
			let validDateString = span.textContent.trim();
			let validDate = new Date(validDateString);
			if (currentDate > validDate)
				span.style.color = 'red';
		});

		//await Utils.refresh_data_visible_roles();
	}

	async add_field()
	{
		await Grape.dialog.open('EmployeeAddField', {});
		this.updateData();
	}

	update_date_of_birth() {
		let id = this.employee().id_number;

		if (id.length === 13 && /^\d+$/.test(id)) {
			let year = id.slice(0, 2);
			let fullYear;
			if (parseInt(year) <= 21) {
				fullYear = '20' + year;  // For years 2000 to 2021
			} else {
				fullYear = '19' + year;  // For years 1922 to 1999
			}

			let month = id.slice(2, 4);
			let day = id.slice(4, 6);

			// Create the date string in YYYY-MM-DD format directly to avoid off-by-one errors
			let dateStr = `${fullYear}-${month}-${day}`;
			let date = new Date(dateStr);

			// Assuming dob_input is an input element
			let dob_input = document.getElementById('dob_input');
			if (dob_input) {
				dob_input.value = dateStr; // Use the pre-formatted date string
				this.employee().date_of_birth = dob_input.value;
			}
		} 
	}

	validate_passport(passportNumber) {
    // Remove any spaces and convert to uppercase
    const cleanPassport = passportNumber.replace(/\s/g, '').toUpperCase();
    
    // Basic passport validation rules
    const validationResult = {
        valid: true,
        save: true,
        message: ''
    };
    
    // Check minimum length (most passports are at least 6 characters)
    if (cleanPassport.length < 6) {
        validationResult.valid = false;
        validationResult.save = false;
        validationResult.message = 'Passport number must be at least 6 characters long.';
        return validationResult;
    }
    
    // Check maximum length (most passports are no more than 12 characters)
    if (cleanPassport.length > 12) {
        validationResult.valid = false;
        validationResult.save = false;
        validationResult.message = 'Passport number must be no more than 12 characters long.';
        return validationResult;
    }
    
    // Check if it contains only alphanumeric characters
    const alphanumericRegex = /^[A-Z0-9]+$/;
    if (!alphanumericRegex.test(cleanPassport)) {
        validationResult.valid = false;
        validationResult.save = false;
        validationResult.message = 'Passport number can only contain letters and numbers.';
        return validationResult;
    }
    
    // Check if it's not all numbers (most passports have at least one letter)
    const allNumbersRegex = /^\d+$/;
    if (allNumbersRegex.test(cleanPassport)) {
        validationResult.valid = false;
        validationResult.message = 'Warning: Passport number appears to be all numbers. Most passport numbers contain both letters and numbers.';
        return validationResult;
    }
    
    // Check for obviously invalid patterns like "12345", "123456", etc.
    const simplePatterns = [
        /^12345\d*$/, // Starts with 12345
        /^(\d)\1+$/, // Same digit repeated
        /^(ABC|XYZ|TEST|DEMO)/i // Common test patterns
    ];
    
    for (let pattern of simplePatterns) {
        if (pattern.test(cleanPassport)) {
            validationResult.valid = false;
            validationResult.message = 'Warning: This appears to be a test or invalid passport number.';
            return validationResult;
        }
    }
    
    return validationResult;
}

// Modified save_personal_details method with passport validation
async save_personal_details(v, e) {
    let tbody = $(e.currentTarget).parent().parent().parent().parent();
    let data = ko.toJS(v);
    data.fields = [];
    let employee_fields = this.employee_fields_lookup();

    employee_fields.forEach((category) => {
        category.resdata.forEach((f) => {
            data.fields.push({ field_name: f.field_name, field_value: f.field_value, valid_date: f.valid_date })
        });
    });

    delete data.__ko_mapping__;// remove the redundant KO data

    data.id_type = this.selected_id_type();
    data.id_country = this.selected_id_country();

    let checkId;
    let msg;

    if (this.selected_id_type() == 'SA ID') {
        checkId = Utils.validate_id(data.id_number);
        msg = checkId.message;

        if (checkId.save == false) {
            Grape.alerts.alert({ type: 'error', message: msg, title: tr('Validation Error') });
            return;
        }
        else if (checkId.valid == false) {
            let response = await Grape.alerts.confirm({ 
                type: 'warning', 
                title: tr('SA ID number Validation'), 
                message: msg + tr('Do you wish to continue with ID number: ') + data.id_number + '?', 
                accept_text: tr('Proceed'), 
                cancel_text: tr('Cancel') 
            });

            if (response) {
                data.id_type = 'Other';
                data.id_country = 'Any Country Not On This List';
            }
            else {
                return;
            }
        }
    }
    // Add passport validation
    else if (this.selected_id_type() == 'Passport') {
        checkId = this.validate_passport(data.id_number);
        msg = checkId.message;

        if (checkId.save == false) {
            Grape.alerts.alert({ type: 'error', message: msg, title: tr('Validation Error') });
            return;
        }
        else if (checkId.valid == false) {
            let response = await Grape.alerts.confirm({ 
                type: 'warning', 
                title: tr('Passport Number Validation'), 
                message: msg + tr(' Do you wish to continue with passport number: ') + data.id_number + '?', 
                accept_text: tr('Proceed'), 
                cancel_text: tr('Cancel') 
            });

            if (!response) {
                return;
            }
        }
    }

    //if id isn't SA id, prompt warning, if it is a SA id, save the changes
    if (data.date_of_birth == null || data.date_of_birth == '') {
        Grape.alerts.alert({ type: 'error', message: tr('No date of birth input.'), title: tr('Missing information') });
    }
    else {
        let res = await Grape.fetches.postJSON('/employee/save', data);

        if (res.status == 'OK') {
            tbody.find('.view').hide();
            tbody.find('.edit').show();
            this.updateData();
        }
        else if (res.status == 'ERROR') {
            Grape.alerts.alert({ type: 'error', title: tr('Error'), message: res.message })
            tbody.find('.view').hide();
            tbody.find('.edit').show();
            // this.updateData();
        }
    }
}

	async save_disciplinary_details(v, e) {
		let tbody = $(e.currentTarget).parent().parent().parent().parent();
		let data = ko.toJS(v);
		data.fields = [];
		let employee_fields = this.employee_fields_lookup();

		employee_fields.forEach((category) => {
			category.resdata.forEach((f) => {
				data.fields.push({ field_name: f.field_name, field_value: f.field_value, valid_date: f.valid_date })
			});
		});

		delete data.__ko_mapping__;// remove the redundant KO data

		let res = await Grape.fetches.postJSON('/employee/save', data);
		if (res.status == 'OK') {
			//tbody.find('.view').hide();
			//tbody.find('.edit').show();
			this.updateData();
		}
		else if (res.status == 'ERROR') {
			Grape.alerts.alert({ type: 'error', title: tr('Error'), message: res.message });
			tbody.find('.view_disciplinary').hide();
			tbody.find('.edit_disciplinary').show();
			// this.updateData();
		}
	}

	edit_disciplinary_details(v, e) {
		let tbody = $(e.currentTarget).parent().parent().parent().parent().parent()
		tbody.find('.view_disciplinary').hide();
		tbody.find('.edit_disciplinary').show();
	
		if (document.getElementById('txtFieldValue'))
			autocomplete(document.getElementById('txtFieldValue'), global_AutoComplete_Dictionary);
	}

	cancel_save_disciplinary_details(v, e) {
		let tbody = $(e.currentTarget).parent().parent().parent().parent()
		tbody.find('.view_disciplinary').show();
		tbody.find('.edit_disciplinary').hide();
	
		this.updateData();
	}

	cancel_save_educational_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent()
		tbody.find('.view').show();
		tbody.find('.edit').hide();
		d
		this.updateData();
		//location.reload();
	}

	async save_educational_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent();
		let data = ko.toJS(v);
		data.fields = [];
		let employee_fields = this.employee_fields_lookup();

		employee_fields.forEach((category) => {
			category.resdata.forEach((f) => {
				data.fields.push({ field_name: f.field_name, field_value: f.field_value, valid_date: f.valid_date })
			});
		});

		delete data.__ko_mapping__;// remove the redundant KO data

		let res = await Grape.fetches.postJSON('/employee/save', data);
		if (res.status == 'OK')
		{
			//tbody.find('.view').hide();
			//tbody.find('.edit').show();
			this.updateData();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.alert({ type: 'error', title: tr('Error'), message: res.message });
			tbody.find('.view_educational').hide();
			tbody.find('.edit_educational').show();
			// this.updateData();
		}
	}

	async save_disciplinary_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent();
		let data = ko.toJS(v);
		data.fields = [];
		let employee_fields = this.employee_fields_lookup();

		employee_fields.forEach((category) => {
			category.resdata.forEach((f) => {
				data.fields.push({ field_name: f.field_name, field_value: f.field_value, valid_date: f.valid_date })
			});
		});

		delete data.__ko_mapping__;// remove the redundant KO data

		let res = await Grape.fetches.postJSON('/employee/save', data);
		if (res.status == 'OK')
		{
			//tbody.find('.view').hide();
			//tbody.find('.edit').show();
			this.updateData();
		}
		else if (res.status == 'ERROR')
		{
			Grape.alerts.alert({ type: 'error', title: tr('Error'), message: res.message });
			tbody.find('.view_disciplinary').hide();
			tbody.find('.edit_disciplinary').show();
			// this.updateData();
		}
	}

	async send_invitation_email()
	{
		let response = await Grape.alerts.confirm({ type: 'info', title: tr('Confirm'), message: tr('Are you sure you want to send this employee an invite to use the system?') });

		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/send_invitation_email', { employee_id: this.employee_id() });
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully sent an invitation email.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async send_app_email(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'info', title: tr('Confirm'), message: tr('Are you sure you want to send this employee an invite to use the mobile application?') });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/send_mobile_app_email', { employee_id: this.employee_id() });
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully sent an invitation email.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	edit_qualification(v, e)
	{
		let row = $(e.currentTarget).parent().parent();
		row.find('.edit').show();
		row.find('.view').hide();
	}

	async delete_qualification(v, e)
	{
		let data = ko.toJS(v);

		let response = await Grape.alerts.confirm({ type: 'danger', title: tr('Warning'), message: tr('Are you sure you want to remove this entry?') });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/employee_education/delete', data);
			if (res.status == 'OK')
			{
				await Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted entry.'), title: tr('Success') });
				this.loadPage();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async save_qualification(v, e)
	{
		let data = ko.toJS(v);
		let row = $(e.currentTarget).parent().parent();
		let valid = true;
		let msg = '';

		if (!data.institution)
		{
			valid = false;
			msg = tr('Institution can not be blank');
		}
		else if (!data.qualification)
		{
			valid = false;
			msg = tr('Qualification can not be blank');
		}

		if (valid == true)
		{
			if (data.education_id == null)
			{
				let res = await Grape.fetches.postJSON('/employee/save_employee_education/save', { employee_id: this.employee_id(), institution: data.institution, qualification: data.qualification });
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully saved education.'), title: tr('Success') });
					this.loadPage();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
			else
			{
				// edit
				let res = await Grape.fetches.postJSON('/employee/save_employee_education/edit', {
					education_id: data.education_id,
					employee_id: this.employee_id(),
					institution: data.institution,
					qualification: data.qualification,
				});

				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully updated education.'), title: tr('Success') });
					this.loadPage();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}

			// post json
			row.find('.edit').hide();
			row.find('.view').show();
		}
		else
			Grape.alerts.alert({ type: 'error', message: msg, title: 'Validation Error' });
	}

	cancel_edit(v, e)
	{
		this.qualifications.remove(v);
	}


	async upload_photo(v, e)
	{
		await Grape.dialog.open('EmployeeUploadPhoto', { employee_id: this.employee_id() });
	}

	async delete_photo(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this profile picture?') });
		if (response)
		{
			let res = await Grape.fetches.postJSON('/employee/delete_photo', { employee_id: this.employee_id() });
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully deleted profile photo.'), title: tr('Success') });
				location.reload();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error') });
		}
	}

	// HELP DIALOG
	show_employee_details_help()
	{
		Grape.dialog.open('EmployeDetailsHelp', { employee_id: this.logged_in_employee_id });
	}

	show_educational_details_help()
	{
		Grape.dialog.open('SkillsCompetencyHelp', { employee_id: this.logged_in_employee_id });
	}

	edit_personal_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent();
		tbody.find('.view').hide();
		tbody.find('.edit').show();

		if (document.getElementById('txtFieldValue'))
			autocomplete(document.getElementById('txtFieldValue'), global_AutoComplete_Dictionary);
	}

	edit_educational_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent()
		tbody.find('.view').hide();
		tbody.find('.edit').show();

		if (document.getElementById('txtFieldValue'))
			autocomplete(document.getElementById('txtFieldValue'), global_AutoComplete_Dictionary);
	}

	cancel_save_personal_details(v, e)
	{
		let tbody = $(e.currentTarget).parent().parent().parent().parent()
		tbody.find('.view').show();
		tbody.find('.edit').hide();
		localStorage.setItem('last-profile-tab', 'general-tab');
		this.updateData();
		//location.reload();
	}

	show_education_help(v, e)
	{
		Grape.dialog.open('EducationHelp', { employee_id: this.logged_in_employee_id });
	}
};

export default {
	name: 'employee_view_general_component',
	viewModel: EmployeeViewGeneralComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_general_component'
};
